import React from 'react';
import { motion } from 'framer-motion';
import { CtaShimmer } from './CtaShimmer';
import { Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-16 md:py-32 px-4 bg-navy text-white text-center relative overflow-hidden" data-id="element-99">
      {/* Technical background elements */}
      <div className="absolute inset-0 bg-[radial-gradient(#1e293b_1px,transparent_1px)] [background-size:20px_20px] opacity-30" data-id="element-100"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-101">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="inline-flex items-center gap-2 bg-electric/10 border border-electric/30 px-6 py-2 rounded mb-8" data-id="element-102">
          <Zap className="text-electric w-4 h-4" data-id="element-103" />
          <span className="text-electric text-xs md:text-sm font-black uppercase tracking-widest" data-id="element-104">
            OFERTA ESPECIAL DE LANZAMIENTO
          </span>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-4xl md:text-7xl lg:text-8xl font-black mb-6 leading-tight text-white" data-id="element-105">
          MEGA KIT ELECTRICISTA PRO™ <br data-id="element-106" />
          <span className="text-electric" data-id="element-107">EDICIÓN LATAM</span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-slate-300 text-lg md:text-2xl font-semibold mb-12 max-w-3xl mx-auto leading-relaxed bg-slate-800/50 p-6 rounded border border-slate-700 backdrop-blur-sm" data-id="element-108">
          Aprende electricidad práctica y ten todo el material técnico para
          instalar, reparar, leer diagramas y presupuestar con más seguridad. No
          empieces desde cero.
        </motion.p>

        <motion.button animate={{
        y: [0, -4, 0],
        boxShadow: ['0 8px 0 rgb(200,160,0), 0 0 0px rgba(255,210,0,0)', '0 8px 0 rgb(200,160,0), 0 0 32px rgba(255,210,0,0.5)', '0 8px 0 rgb(200,160,0), 0 0 0px rgba(255,210,0,0)']
      }} whileHover={{
        scale: 1.03,
        boxShadow: '0 8px 0 rgb(200,160,0), 0 0 44px rgba(255,210,0,0.75)'
      }} whileTap={{
        scale: 0.98
      }} initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        y: {
          duration: 2.8,
          repeat: Infinity,
          ease: 'easeInOut'
        },
        boxShadow: {
          duration: 2.8,
          repeat: Infinity,
          ease: 'easeInOut'
        },
        opacity: {
          delay: 0.3
        }
      }} onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} className="relative overflow-hidden w-full max-w-xl bg-electric hover:bg-yellow-400 text-navy font-black text-xl md:text-3xl py-6 md:py-8 rounded mb-12 uppercase tracking-tight transition-colors" data-id="element-109">
          <CtaShimmer data-id="element-110" />
          <span className="relative z-10" data-id="element-111">
            ⚡ → ACCEDER AL MEGA KIT POR USD 14.00
          </span>
        </motion.button>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="flex flex-col items-center gap-6" data-id="element-112">
          <div className="flex items-center gap-3 bg-white/5 px-6 py-2 rounded border border-white/10" data-id="element-113">
            <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse shadow-[0_0_10px_rgba(34,197,94,0.8)]" data-id="element-114" />
            <span className="text-white text-sm md:text-base font-black uppercase tracking-widest" data-id="element-115">
              +500 técnicos y estudiantes ya accedieron
            </span>
          </div>
          <p className="text-slate-400 text-[10px] md:text-xs font-semibold uppercase tracking-widest max-w-2xl leading-relaxed" data-id="element-116">
            Acceso digital inmediato • Pago seguro y protegido • Conversión a
            moneda local en el checkout • Garantía de 7 días
          </p>
        </motion.div>
      </div>
    </section>;
}